<template>
  <div>
    <div class="content-main" v-for="(add,index) in adds">
      <div class="conyentOne" >
        <input type="text" name="" class="conyentOne-txt">
      </div>
      <div class="conyentOne-btn">
        <input type="button" name="" value="预览"
               style="background: #fff url(../../../static/searchImg/Eye.png) no-repeat;">
        <input type="button" name="" value="修改"
               style="background: #fff url(../../../static/searchImg/modify.png) no-repeat;">
        <input type="button" name="" value="删除" style="color: #ff0000; border: 1px solid #ff0000;
              background: #fff url(../../../static/searchImg/delete.png) no-repeat;">
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "operation",
    data(){
      return{
        adds: 4,
      }
    }
  }
</script>

<style scoped>
  .conyentOne{
    width: 608px;
    height: 35px;
    margin: 3px 0 5px 15px;
    float: left;
    margin-right: 12px;
  }

  .conyentOne-txt{
    width: 610px;
    height: 35px;
    border-radius: 5px;
    border: 1px solid #000;
    font-size: 18px;
  }

  .conyentOne-btn{
    width: 285px;
    height: 35px;
    float: left;
    margin-top: 2px;
  }

  .conyentOne-btn input[type="button"]{
    width: 90px;
    height: 35px;
    border-radius: 5px;
    background-color: #fff;
    color: #1182d8;
    cursor: pointer;
    text-indent: 1em;
    font-size: 21px;
    border: 1px solid #64a9ea;
  }
</style>



// WEBPACK FOOTER //
// src/pages/search/components/operation.vue